export default __webpack_public_path__ + "static/media/blocks.a2d45095.png";